import React from 'react';

import { RouteObject } from 'react-router-dom';
import { routeDirectory } from 'modules';

import { OrderLookupActivity } from './OrderLookupActivity/OrderLookupActivity';
import { OrderDetailActivity } from './OrderDetailActivity/OrderDetailActivity';
import { StoreReferralActivity } from './StoreReferralActivity/StoreReferralActivity';



export const routes: RouteObject[] = [
  {
    path: routeDirectory.customer.orderLookup.raw,
    element: <OrderLookupActivity />
  },
  {
    path: routeDirectory.customer.orderDetail.raw,
    element: <OrderDetailActivity />
  },
  {
    path: routeDirectory.customer.storeReferral.raw,
    element: <StoreReferralActivity />
  }
];
